<ng-sidebar-container>
  <div ng-sidebar-content>
    <ngx-page-container>
      <h1>Open Orders</h1>
      <hr>


      <div style="margin-left:1em;min-width:35em">
        <label><b>Filter</b></label>
        <div class="row ml-1">
          <div style="width:25em">
            <ngx-doc-form-multiselect [(value)]="filter.issuer" [options]="issuerOptions" [multi]="false" placeholder="Select Issuer"></ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect [(value)]="filter.country" [options]="countryOptions" placeholder="Select Countries"></ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect [(value)]="filter.manager" [options]="employeeOptions" [multi]="false" placeholder="Select Manager"></ngx-doc-form-multiselect>
          </div>
          <div style="width: 42em">
            <ngx-doc-form-multiselect [(value)]="filter.customers" [options]="data.businessOptions" (valueChange)="customersChanged($event)"
              [checkbox]="true" [maxSelectedItems]="3" placeholder="Select customer(s)">
            </ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect *ngIf="filter.customers?.length" [(value)]="filter.customerDocumentNumbers" [checkbox]="true"
              [options]="customerReferenceOptions" placeholder="Customer reference(s)">
            </ngx-doc-form-multiselect>

            <ngx-doc-form-multiselect *ngIf="filter.businessUnits" [(value)]="filter.businessUnits" [options]="data.businessUnitOptions"
              [checkbox]="true" placeholder="Select business unit(s)">
            </ngx-doc-form-multiselect>
          </div>
        </div>

        <div class="mt-4" style="max-width:57em">
          <ngx-form-multi-select [checkbox]="true" title="Select Finished Products" [businessId]="finishedProductBusinessId" [mode]="'column-select'" [(value)]="filter.finishedProducts" [options]="data.finishedProductOptions">
          </ngx-form-multi-select>
        </div>
      </div>

      <br>
      <div>
        <button class="btn btn-info btn-lg" (click)="reload()">Apply Filter</button>
      </div>
      <br>

      <ngx-reports-printer *ngIf="search" #reportsPrinter [search]="search" [pdfSidebar]="true" [printCount]="true" [messaging]="true" [noheader]="true" (done)="reportLoaded()"></ngx-reports-printer>

    </ngx-page-container>
  </div>
</ng-sidebar-container>

